<!-- Login/registration page ( Still show login screen when error)-->
<ng-container *ngIf="(authValid$ | async) === false">
  <nk-login-unauthenticated *ngIf="authInfo$ | async as authInfo" [authInfo]="authInfo"> </nk-login-unauthenticated>
</ng-container>

<!--Choose customer page-->
<ng-container *ngIf="(authValid$ | async) && (authInfo$ | async) && !(identity$ | async)">
  <nk-layout-centered columnClasses="col-lg-10 col-sm-12" *ngIf="isLoadingIdentities">
    <nk-spinner class="me-1" display="inline-block"></nk-spinner>
    {{ 'login.authentication_loading' | translate }}
  </nk-layout-centered>
  <nk-layout-centered columnClasses="col-lg-10 col-sm-12" *ngIf="error">
    <div class="alert alert-danger mb-0">
      <h5 class="font-weight-bold">
        <i class="fa fa-exclamation-triangle me-2"></i>{{ 'login.authentication_error.title' | translate }}
      </h5>
      <p class="mb-0" [innerHtml]="'login.authentication_error.message' | translate"></p>

      <button class="btn btn-light mt-2" (click)="logoutAndRedirectToLogin()">
        {{ 'login.authentication_error.logout' | translate }}
      </button>
    </div>
  </nk-layout-centered>
  <nk-login-authenticated
    *ngIf="!error"
    (logoutAndRedirectToLogin)="logoutAndRedirectToLogin()"
    (logoutClick)="onLogoutClick()"
    (dashboardClick)="onDashboardClick()"
    (customerClick)="onChoosingCustomer($event)"
    [authInfo]="authInfo$ | async"
    [identity]="identity$ | async"
    [identityList]="identityList$ | async">
  </nk-login-authenticated>
</ng-container>
<ng-container *ngIf="loading"></ng-container>
